<!--二次登录认证-->
<template>
  <div class="container">
    <div class='login-box' v-if="show">
      <div class="auth-box">
        <h1 class="login-way">选择认证方式</h1>
        <el-alert
          title="该应用要求使用强密码登录，由于您的密码过于简单，为了您的信息安全，需要进行二次验证。"
          type="warning"></el-alert>
        <div class="login-way-list">
          <div class="login-way wechat" @click="$router.push('/again_login?auth_way=wechat')">
            <p class="login-way-name">微信认证</p>
          </div>
          <div class="login-way mobile" @click="$router.push('/again_login?auth_way=mobile')">
            <p class="login-way-name">短信认证</p>
          </div>
        </div>
      </div>
    </div>

    <div class='login-box' v-else>
      <div class="auth-box">
        <el-alert
          :closable="false"
          title="非法访问"
          type="warning"></el-alert>
      </div>
    </div>
  </div>
</template>

<script>
  import { getToken } from '@/utils/auth'

  export default {
    data() {
      return {
        show: true,
        smsLoginForm: {}
      }
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        let token = getToken()
        if (!token) {
          // 如果不存在，则显示空白页面
          this.show = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/styles/login-list.scss';
</style>>